import React, { useEffect, useState } from "react";
import Card from "../Card/Card";
import Whistlist from "../Whistlist/Whistlist";

import "./Main.css";

const Main = () => {
  const [comics, setComics] = useState([]);
  const [whistlist, setWhistlist] = useState([]);

  useEffect(() => {
    fetch("./data.json")
      .then((res) => res.json())
      .then((data) => setComics(data));
  }, []);

  const addToWhistlist = (item) => {
    const founded = whistlist.find((i) => i.id === item.id);
    if (founded) {
      return;
    }
    setWhistlist([...whistlist, item]);
  };

  return (
    <div className="main">
      <div className="card-container">
        {comics.map((comic) => (
          <Card
            key={comic.id}
            comic={comic}
            addToWhistlist={(item) => addToWhistlist(item)}
          />
        ))}
      </div>
      <div className="whistlist-container">
        <Whistlist whistlist={whistlist} />
      </div>
    </div>
  );
};

export default Main;
